import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BillingFacade } from '@app/shared/+state/billing';

@Component({
  standalone: false,
  selector: 'sbnb-confirmation-summary',
  templateUrl: './confirmation-summary.component.html',
  styleUrls: ['./confirmation-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationSummaryComponent implements OnInit {
  public newPlan$ = this.billingFacade.pendingSubscriptionChangePlan$;
  public currentSubscription$ = this.billingFacade.subscription$;

  constructor(private readonly billingFacade: BillingFacade) { }

  ngOnInit(): void { }
}
